export const roles: GameRoleId[] = [
  "rent-lord",
  "wall-street-wolf",
  "private-buyer",
  "auction-strategist",
  "card-stealer",
  // "the-constructor",
  "financer",
]
export const botConstants = {
  rollAgainThreshold: 100,
  get10PercentFromAllPlayersThresholdPerPlayer: 500,
  get10PercentFromPlayerThreshold: 1000,
  get20PercentFromPlayerThreshold: 800,
  propertyTaxThreshold: { 2: 9, 3: 7, 4: 5 },
  getInterestThreshold: {
    mainMoney: 800,
    stockMoney: 0,
  },
  safePlayFactor: 1,
}
export type BotGender = "male" | "female"

// The gender is what picks a bot's avatar in the frontend (see
// getPlayerAvatar), so every name added here needs one.
export const botProfiles: { name: string; gender: BotGender }[] = [
  { name: "John", gender: "male" },
  { name: "Jenny", gender: "female" },
  { name: "Tom", gender: "male" },
  { name: "Jack", gender: "male" },
  { name: "Harry", gender: "male" },
  { name: "Emma", gender: "female" },
  { name: "Bob", gender: "male" },
  { name: "Alice", gender: "female" },
  { name: "Charlie", gender: "male" },
  { name: "Diana", gender: "female" },
  { name: "Ethan", gender: "male" },
  { name: "Fiona", gender: "female" },
  { name: "George", gender: "male" },
  { name: "Hannah", gender: "female" },
  { name: "Isaac", gender: "male" },
  { name: "Julia", gender: "female" },
  { name: "Kevin", gender: "male" },
  { name: "Liam", gender: "male" },
  { name: "Mia", gender: "female" },
  { name: "Noah", gender: "male" },
  { name: "Olivia", gender: "female" },
  { name: "Patrick", gender: "male" },
  { name: "Quinn", gender: "female" },
  { name: "Ryan", gender: "male" },
  { name: "Sarah", gender: "female" },
  { name: "Thomas", gender: "male" },
  { name: "Uma", gender: "female" },
  { name: "Victor", gender: "male" },
  { name: "Wendy", gender: "female" },
  { name: "Xavier", gender: "male" },
  { name: "Yara", gender: "female" },
  { name: "Zane", gender: "male" },
]

export const botNames = botProfiles.map((profile) => profile.name)

// Bots only ever carry a display name across to the frontend, so the gender has
// to be looked back up from it. Undefined for anything that is not a bot name.
export const getBotGender = (username?: string): BotGender | undefined =>
  botProfiles.find((profile) => profile.name === username)?.gender

// Position of a name within the names of its own gender — used to spread bots
// across the avatars available for that gender, so a given bot always looks the
// same and neighbouring names in the list never share a face.
export const getBotGenderIndex = (username?: string): number =>
  Math.max(
    botProfiles
      .filter((profile) => profile.gender === getBotGender(username))
      .findIndex((profile) => profile.name === username),
    0
  )
